<template>
  <CustomTitleBar title="关于我们" />
  <div class="page-content">
    <!-- Logo区域 -->
    <div class="logo-section">
      <img src="@/assets/images/logo.png" class="app-logo" />
      <div class="version">版本号: 1.3.8</div>
    </div>

    <!-- 链接列表 -->
    <div class="link-list">
      <div class="link-item">
        <span>用户协议</span>
        <van-icon name="arrow" />
      </div>
      <div class="link-item">
        <span>隐私政策</span>
        <van-icon name="arrow" />
      </div>
      <div class="link-item">
        <span>版本更新</span>
        <van-icon name="arrow" />
      </div>
      <div class="link-item">
        <span>儿童个人信息保护政策</span>
        <van-icon name="arrow" />
      </div>
    </div>

    <!-- 底部版权信息 -->
    <div class="copyright">
      <p>海南梦与前方科技有限公司 版权所有</p>
      <p>Copyright © 2023 JingBao. All Right Reserved.</p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import CustomTitleBar from "@/components/CustomTitleBar/index.vue";
import { onMounted } from "vue";

onMounted(() => { })
</script>

<style lang="scss" scoped>
.page-content {
  padding-top: 44px;

  .logo-section {
    padding: 50px 0;
    display: flex;
    flex-direction: column;
    align-items: center;

    .app-logo {
      width: 80px;
      height: 80px;
      border-radius: 16px;
    }

    .version {
      margin-top: 10px;
      color: #666;
      font-size: 14px;
    }
  }

  .link-list {
    .link-item {
      padding: 14px 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      background-color: #fff;
      border-bottom: 1px solid #f5f5f5;

      &:last-child {
        border-bottom: none;
      }
    }
  }

  .copyright {
    position: fixed;
    bottom: 20px;
    left: 0;
    right: 0;
    text-align: center;
    color: #999;
    font-size: 12px;

    p {
      margin: 5px 0;
    }
  }
}
</style>
